export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/pianissimo-icon.svg?d137bed9a64f5d016235251e760c9298";